import React from "react";
import "../assets/styles/HomePage.css";



function PrivacyPolicyDe() {
  return (
  <>
    {/* ✅ Helmet for SEO & Metadata */}

    <div className="home-page">    
      <div className="recommended-use-cases">
        <h1>Datenschutzerklärung  🔒</h1>
        <p><strong> Updated: 01.03.2025 </strong></p>
        <p>
          Willkommen bei download-videos ("Plattform", "wir", "uns" oder "unser"). Diese Datenschutzerklärung erklärt, wie wir Ihre Informationen erfassen, verwenden, offenlegen und schützen, wenn Sie unsere Dienste nutzen. Bitte lesen Sie sie sorgfältig. ✅
        </p>
        <h2>1. Welche Informationen wir erfassen 📊</h2>
        <p>
          Wir erfassen und verarbeiten die folgenden Arten von Informationen:
          <h3> a)- Informationen, die Sie bereitstellen 📝</h3>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>Kontoregistrierungsdetails (z. B. Name, E-Mail, Passwort)</li>
            <li>Hochgeladene Inhalte (z. B. Audio-/Videodateien zur Transkription)</li>
            <li>Jegliche Kommunikation mit uns (z. B. Kundenanfragen)</li>
          </ul>
          <h3> b)-  Automatisch erfasste Informationen 🚀</h3>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li> Nutzungsdaten (z. B. besuchte Seiten, genutzte Funktionen, Interaktionsdaten)</li>            
            <li> Cookies und Tracking-Technologien (siehe Cookie-Richtlinie unten)</li>
          </ul>
          <h3> c)- Informationen aus Drittanbieter-Anmeldediensten 🔗</h3>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li> Wenn Sie sich über Google anmelden, können wir auf Ihre E-Mail-Adresse und Ihr Profil zugreifen, um Ihr Konto zu erstellen und zu verwalten.</li>
          </ul>
        </p>

        
        <h2>2. Wie wir Ihre Informationen verwenden ⚙️</h2>
        <p>
        Wir verwenden die gesammelten Daten für folgende Zwecke:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li> Zur Bereitstellung und Verbesserung unserer Transkriptionsdienste 🎙️ </li>
            <li> Zur Personalisierung der Benutzererfahrung und Optimierung der Plattformleistung</li>
            <li> Zur Beantwortung von Anfragen und Bereitstellung von Kundensupport 📩</li>
            <li> Zur Durchsetzung unserer Nutzungsbedingungen und Gewährleistung der Sicherheit 🔐</li>
            <li> Zur Analyse von Nutzungstrends und Verbesserung unserer Funktionen 📈</li>
          </ul>
        </p>          
        <h2>3. Wie wir Ihre Informationen weitergeben 🔄</h2>
        <p>
        Wir verkaufen, handeln oder vermieten Ihre personenbezogenen Daten nicht. Allerdings können wir Informationen mit folgenden Parteien teilen:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li><strong>Dienstleister</strong>: Dritte, die uns beim Betrieb und der Verbesserung unserer Plattform unterstützen (z. B. Cloud-Speicherung, Analysen, Sicherheitsdienste)</li>
            <li><strong>Rechtliche Verpflichtungen</strong>: Falls gesetzlich erforderlich oder zum Schutz unserer Rechte und zur Verhinderung von Betrug ⚖️</li>
            <li><strong>Geschäftsübertragungen</strong>: Im Falle einer Fusion, eines Verkaufs oder einer Übernahme können Ihre Daten übertragen werden 📁</li>
          </ul>
        </p>          

        <h2>4. Datenspeicherung & Kontolöschung 🗑️</h2>
        <p>
          By using the Platform, you agree that you will:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>Wir speichern Benutzerdaten so lange, wie es für die Bereitstellung der Dienste und die Einhaltung gesetzlicher Anforderungen erforderlich ist.</li>
            <li>Benutzer können jederzeit die <strong> vollständige Löschung ihres Kontos</strong> über ihre Kontoeinstellungen beantragen.</li>
            <li> Nach der Löschung werden alle Benutzerdaten, einschließlich Transkripte und Kontoinformationen, <strong>dauerhaft entfernt</strong>. </li>
          </ul>
        </p>          

        <h2>5. Sicherheitsmaßnahmen 🔐</h2>
        <p>
          Wir setzen branchenübliche Sicherheitsmaßnahmen ein, um Benutzerdaten zu schützen, darunter:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li> Verschlüsselung gespeicherter und übertragener Daten 🛡️ </li>
            <li> Zugriffskontrollen und Authentifizierungsmechanismen 🔑</li>
            <li> Regelmäßige Sicherheitsprüfungen und Überwachung 🕵️‍♂️</li>
          </ul>
        </p>          

        <h2>6. Cookies & Tracking-Technologien 🍪</h2>
        <p>
          Wir verwenden Cookies und ähnliche Tracking-Technologien, um:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li> Benutzerpräferenzen zu speichern und die Benutzererfahrung zu verbessern</li>
            <li> Die Leistung der Website und Benutzerinteraktionen zu analysieren 📊</li>
            <li> Unsere Dienste auf Basis von Nutzungsverhalten zu optimieren Benutzer können Cookies über ihre Browsereinstellungen deaktivieren, aber dies kann die Funktionalität der Plattform einschränken.</li>
          </ul>
        </p>          

        <h2>7. Ihre Rechte & Wahlmöglichkeiten ✊</h2>
        <p>
          Je nach Ihrem Standort können Sie die folgenden Rechte haben:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li> Zugang & Berichtigung: Beantragen Sie Zugang zu oder Berichtigung Ihrer Daten.</li>
            <li> Kontolöschung: Fordern Sie die Löschung Ihres Profils und aller zugehörigen Daten an.</li>
            <li> Opt-Out: Deaktivieren Sie Cookies oder melden Sie sich von Marketingkommunikationen ab.</li>
            <li> Datenübertragbarkeit: Fordern Sie eine Kopie Ihrer Daten in einem strukturierten Format an.</li>
          </ul>
        </p>          

        <h2>8. Änderungen an dieser Richtlinie 🔄</h2>
        <p>
          Wir können diese Datenschutzerklärung regelmäßig aktualisieren. Benutzer werden über wesentliche Änderungen per E-Mail oder Plattformankündigungen informiert. Die fortgesetzte Nutzung unserer Plattform bedeutet die Zustimmung zur aktualisierten Richtlinie.
        </p>          

        <h2>9. Kontaktinformationen 📧</h2>
        <p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li> Bei Fragen zu dieser Datenschutzerklärung erreichen Sie uns unter <a style={{textDecoration: "none", color: "#f1c40f"}} href="https://chaperoneai.net/contact" target="_blank" rel="noopener noreferrer"> here</a>. 📩</li>
            <li> Durch die Nutzung unserer Plattform bestätigen Sie, dass Sie diese Datenschutzerklärung gelesen und akzeptiert haben. ✅</li>
          </ul>
        </p>        
      </div>
    </div>
    </>
  );
}

export default PrivacyPolicyDe;
